import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_bcx5ls1sn7: FaireBrandEntity = {
  token: "b_bcx5ls1sn7",
  type: "brand",
  name: "Kitty Meow Boutique",
  avatarUrl:
    "https://cdn.faire.com/fastly/4d80b93726767303711257e09cfe5033af58b579fe9683ece6116bedf038ab1f.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/29d032a97f7ca5aeca98fd98d49644d32022d883ba14d05414651d078bd17ec2.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/4d80b93726767303711257e09cfe5033af58b579fe9683ece6116bedf038ab1f.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/29d032a97f7ca5aeca98fd98d49644d32022d883ba14d05414651d078bd17ec2.jpeg",
  location: "Naperville, IL, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 336,
  isInsider: true,
  description:
    "Featured In:\nTop 10 Designers to Watch in 2022 by Stationery Trends Magazine  •  Gift Shop Magazine  •  Anchora Magazine  •  The Chicago Tribune  •  and more! \nhttps://kittymeowboutique.com/pages/press\n\n\nAt Kitty Meow Boutique you can shop beautifully designed paper & party goods based on your mood: WITTY or SWEET. Whether you're looking for something super funny, a little rude and mildly inappropriate OR totally sweet, thoughtful, and sentimental...we got ya covered. \n\nKitty Meow products are designed to be FUN, fierce, & make women feel confident, sexy, empowered, and courageous enough to take the bull by the horns in life! We're obsessed with providing an exceptional customer experience to anyone who comes into contact with the Kitty Meow brand. That seriously brings us the GREATEST joy.\n\nLooking forward to serving you and earning your business and trust. \n\nat your creative service,\n\nCatherine | Kitty Meow Boutique \n\n",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:51:21.338Z",
    importedBy: "entity-db-cli",
  },
};
